import { render, staticRenderFns } from "./IntentScoreBadge.vue?vue&type=template&id=031cb2db&scoped=true&"
import script from "./IntentScoreBadge.vue?vue&type=script&lang=js&"
export * from "./IntentScoreBadge.vue?vue&type=script&lang=js&"
import style0 from "./IntentScoreBadge.vue?vue&type=style&index=0&id=031cb2db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031cb2db",
  null
  
)

export default component.exports